export const Boxing = [
    {
    "id": 28,
    "Title": "IES-2024-28",
    "ImageSource": "/Boxing/BoxingGloves/28.jpg",
    "Category": "Bag Gloves"
},
{
    "id": 29,
    "Title": "IES-2024-29",
    "ImageSource": "/Boxing/BoxingGloves/29.png",
    "Category": "Bag Gloves"
},
{
    "id": 30,
    "Title": "IES-2024-30",
    "ImageSource": "/Boxing/BoxingGloves/30.png",
    "Category": "Bag Gloves"
},
]